import instantsearch from 'instantsearch.js';
import { searchBox, hits } from 'instantsearch.js/es/widgets';

window.instantsearch = instantsearch;
window.instantsearch.searchBox = searchBox;
window.instantsearch.hits = hits;
